import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Related articles',
  name: 'relatedArticles',
  type: 'object',
  fields: [
    defineField({
      title: 'Hidden?',
      name: 'hidden',
      type: 'boolean',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      name: 'tags',
      title: 'Tags',
      description:
        'Load articles tagged with selected tags. Note: only articles with "show on wheel landing page" will be used.',
      type: 'array',
      of: [
        {
          name: 'wheelLine',
          title: 'Wheel line',
          type: 'reference',
          to: [
            {
              type: 'line',
            },
          ],
        },
        {
          name: 'wheelDesign',
          title: 'Wheel design',
          type: 'reference',
          to: [
            {
              type: 'design',
            },
          ],
        },
      ],
    }),
    defineField({
      name: 'articles',
      title: 'Featured articles',
      description: 'Manually select articles',
      type: 'array',
      of: [
        {
          type: 'reference',
          to: [{ type: 'article' }],
          options: {
            filter: `showOnWheelLandingPage`,
          },
        },
      ],
      validation: (rule) => [
        rule.unique().error('Each article should be unique'),
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'Related articles',
      }
    },
  },
})